import type { HistorySentinelMetadata } from './history-reconciler-types';

const HISTORY_SENTINEL_KEY = '__sd';
const HISTORY_SENTINEL_OWNER_KEY = '__sdo';

interface SentinelOwnerInput {
  destinationSentinelMetadata: HistorySentinelMetadata | null;
  ownerId: string;
}

export function isCurrentOwnerHistorySentinel(
  input: SentinelOwnerInput,
): input is SentinelOwnerInput & { destinationSentinelMetadata: HistorySentinelMetadata } {
  return input.destinationSentinelMetadata?.owner === input.ownerId;
}

export function getCurrentOwnerDestinationDepth(input: SentinelOwnerInput): number {
  if (!isCurrentOwnerHistorySentinel(input)) {
    return 0;
  }

  return input.destinationSentinelMetadata.depth;
}

function toHistoryStateRecord(state: unknown): Record<string, unknown> {
  if (typeof state === 'object' && state != null) {
    return state as Record<string, unknown>;
  }

  return {};
}

export function getHistorySentinelMetadata(state: unknown): HistorySentinelMetadata | null {
  const stateRecord = toHistoryStateRecord(state);
  const sentinelDepth = stateRecord[HISTORY_SENTINEL_KEY];
  const sentinelOwner = stateRecord[HISTORY_SENTINEL_OWNER_KEY];

  if (typeof sentinelDepth !== 'number' || typeof sentinelOwner !== 'string') {
    return null;
  }

  return {
    depth: sentinelDepth,
    owner: sentinelOwner,
  };
}

export function buildHistorySentinelState(
  state: unknown,
  metadata: HistorySentinelMetadata,
): Record<string, unknown> {
  return {
    ...toHistoryStateRecord(state),
    [HISTORY_SENTINEL_KEY]: metadata.depth,
    [HISTORY_SENTINEL_OWNER_KEY]: metadata.owner,
  };
}

export function stripHistorySentinelState(state: unknown): Record<string, unknown> {
  const stateRecord = toHistoryStateRecord(state);
  const {
    [HISTORY_SENTINEL_KEY]: _sentinelDepth,
    [HISTORY_SENTINEL_OWNER_KEY]: _sentinelOwner,
    ...rest
  } = stateRecord;

  return rest;
}

export function getCurrentHistoryUrl(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
